export default {"src":"/_next/static/media/multiply_regular.b053ec30.svg","height":24,"width":24};